<template>
    <div>

        <div v-if="bookingStore.initialized">
            <transition name="modal">
                <router-view></router-view>
            </transition>
        </div>

        <transition name="modal">
            <modal-booking-time
                v-if="timeSlot.time !== null"
            />
        </transition>

        <div class="booking">
            <div v-if="bookingStore.initialized">
                <booking-searchbar />
                <booking-view-map />
                <booking-view-list v-if="bookingStore.view === 'list'" />
                <booking-view-times v-if="bookingStore.view === 'times'" />
                <booking-navigation />
            </div>
        </div>

    </div>
</template>

<script>
import { mapState, mapStores } from 'pinia'
import { useBookingStore } from '../../stores/bookingStore'

import BookingNavigation from './booking-navigation'
import BookingViewMap from './booking-view-map'
import BookingViewList from './booking-view-list'
import BookingViewTimes from './booking-view-times'
import BookingSearchbar from './booking-searchbar'
import axios from 'axios'
import ModalBookingTime from './modal-booking-time.vue'

export default {
    name: 'booking',
    components: {
        ModalBookingTime,
        BookingNavigation,
        BookingViewMap,
        BookingViewList,
        BookingViewTimes,
        BookingSearchbar
    },
    data () {
        return {

        }
    },
    computed: {
        ...mapStores(useBookingStore),
        ...mapState(useBookingStore, {
            timeSlot: state => state.timeSlot,
            productArea: state => state.productArea
        })
    },
    watch: {
        productArea (val, oldVal) {
            axios.get('/booking/getDurations', {
                params: {
                    product_area_id: this.productArea
                }
            })
                .then(response => {
                    console.log('booking getDurations complete')
                    console.log(response.data)

                    this.bookingStore.$patch({
                        durations: response.data.durations
                    })
                })
        },

        '$route' (to, from) {
            console.log('asd from ' + from.name)
            console.log('asd to ' + to.name)

            if (from.name === 'modal-address' || from.name === 'modal-clinic') {
                return
            }

            if (to.name === 'booking') {
                this.bookingStore.setView('map')
            }
        }
    },
    created () {
        axios.get('/booking/init')
            .then(response => {
                console.log('booking init complete')
                console.log(response.data)

                this.bookingStore.$patch({
                    initialized: true,
                    productAreas: response.data.productAreas,
                    productArea: response.data.preselectedProductArea,
                    durations: response.data.durations
                })
            })
    },
    methods: {

    }
}
</script>
